import { useUserRoles } from '@teetsh/app/src/containers/App/context/useUserRoles';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import TwoColumnsCardSidebar from '@teetsh/app/src/components/TwoColumnsCardSidebar';
import Button from '@teetsh/app/src/components/Buttons/Button';
import 'twin.macro';

export function AccountTeacher() {
  const { t } = useTranslation(['userSettings']);
  const navigate = useNavigate();
  const { hasRoleTeacher } = useUserRoles();

  if (hasRoleTeacher) {
    return (
      <TwoColumnsCardSidebar.Section
        title={t('userSettings:account.teacher.title')}
      >
        <div>
          <p tw="mb-4">{t('userSettings:account.teacher.activated')}</p>
          <div tw="flex gap-2 flex-wrap">
            <Button
              intent="primary"
              outlined
              onClick={() => {
                navigate('/dashboard');
              }}
            >
              {t('userSettings:account.teacher.cta.accessToTeacherAccount')}
            </Button>
          </div>
        </div>
      </TwoColumnsCardSidebar.Section>
    );
  }

  return (
    <TwoColumnsCardSidebar.Section
      title={t('userSettings:account.teacher.title')}
    >
      <div>
        <p tw="mb-4">
          {t('userSettings:account.director.teacherAccount.description')}
        </p>
        <div tw="flex gap-2 flex-wrap">
          <Button
            intent="primary"
            onClick={() => {
              navigate('/demarrage/ecole?mode=add-teacher-role');
            }}
          >
            {t(
              'userSettings:account.director.teacherAccount.cta.createTeacherAccount',
            )}
          </Button>
        </div>
      </div>
    </TwoColumnsCardSidebar.Section>
  );
}
